import { gql, GraphQLClient } from 'graphql-request';

import { NetworkIds } from '~config/rpcConfig';
import { systemStateQuery, transactionQuery } from '~services/subgraph/queries';

import { GraphSystemState, GraphTransactionData } from '../types';

type GetRedeemedTroveStatsRes = {
  trove: {
    changes: {
      systemStateBefore: GraphSystemState;
      systemStateAfter: GraphSystemState;
      redemption: {
        id: string;
        asset: {
          name: string;
        };
        sequenceNumber: number;
        redeemer: { id: string };
        tokensAttemptedToRedeem: string;
        tokensActuallyRedeemed: string;
        collateralRedeemed: string;
        partial: boolean;
        fee: string;
        transaction: GraphTransactionData;
      };
    }[];
  };
};

export default class Redemptions {
  constructor(private readonly client: GraphQLClient, private readonly networkId: NetworkIds) {}

  async getUserRedeemedTroves(user: string, asset: string) {
    const troveId = `${user.toLowerCase()}-${asset.toLowerCase()}`;
    const redeemedTroveQuery = gql`
      query get_redeemed_trove_stats($id: ID) {
        trove(id: $id) {
          changes(where: { redemption_not: null }) {
            ${systemStateQuery}
            redemption {
              id
              asset { 
                name
              }
              sequenceNumber
              redeemer { 
                  id 
              }
              tokensAttemptedToRedeem
              tokensActuallyRedeemed
              collateralRedeemed
              partial
              fee
              ${transactionQuery}
            }
          }
        }
      }
    `;

    const res: GetRedeemedTroveStatsRes = await this.client.request(redeemedTroveQuery, {
      asset,
      id: troveId,
    });

    return res.trove.changes.map(({ systemStateAfter, systemStateBefore, redemption }) => ({
      systemStateBefore,
      systemStateAfter,
      ...redemption,
    }));
  }
}
